import Quimbee from "quimbee"
import AdBlockerChecker from "utils/ad_blocker_checker"
import Modal from 'components/modal'

class HubSpotForm {
  async initialize(formId, target) {
    const checker = new AdBlockerChecker("//js.hsforms.net/forms/embed/v2.js")
    await checker.call(() => { this.setupForm(formId, target) }, this.displayModal)
  }

  setupForm(formId, target) {
    this.checkForSDK(() => {
      hbspt.forms.create({
        target: target,
        region: "na1",
        portalId: Quimbee.data.hubSpotPortalId,
        formId: formId,
        onFormSubmitted: () => {
          this.onFormSubmitted(target)
        }
      })
    })
  }

  displayModal(e) {
    Modal.show("blocked_form_modal")
  }

  checkForSDK(success) {
    const LOOP_WAIT = 1000
    const MAX_LOOPS = 30
    let loopCount = 0

    if(typeof window.hbspt === 'undefined'){
      loopCount += 1
      if(loopCount < MAX_LOOPS)
        setTimeout(this.checkForSDK, LOOP_WAIT, success)
    } else {
      success()
    }
  }
}

export default HubSpotForm
